// extracted by mini-css-extract-plugin
module.exports = {"toggleButton":"LangDropdown_toggleButton__38dBT"};